import { Offers } from '../domain/Offers';
import { OffersRepository } from '../domain/OffersRepository';

export async function getAllOffers(
  offersRepository: OffersRepository,
  leaseId: string
): Promise<Offers> {
  return await offersRepository.getAll(leaseId);
}
